import React from 'react';

const Item = ({item}) => {
    return <details className="details">
        <summary>{item.title}</summary>
        <ul className="content">
            {item.text.map((el, i) => {
                return <li key={i}>
                    <p>
                        {el}
                    </p>
                </li>
            })}

        </ul>
    </details>
}

const Accordion = ({items}) => {
    return (
        <div className={'accordion_wrapper'}>
            {items.map(item => {
                return <Item
                    key={item.key}
                    item={item}
                />
            })}
        </div>
    );
};

export default Accordion;